import { render, staticRenderFns } from "./preloader-component.vue?vue&type=template&id=ab892762&scoped=true"
import script from "./preloader-component.ts?vue&type=script&lang=ts&external"
export * from "./preloader-component.ts?vue&type=script&lang=ts&external"
import style0 from "./preloader-component.scss?vue&type=style&index=0&id=ab892762&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab892762",
  null
  
)

export default component.exports